import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from './../AppContext';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter, UncontrolledTooltip, Progress, Row, Col } from 'reactstrap';
import { BsCardChecklist, BsFilePdfFill, BsChatLeftTextFill, BsFillCalendarDateFill, BsFileEarmarkExcelFill } from 'react-icons/bs';
import { Icon } from "./Icon";
import { Accion } from "./Accion";
import { Paginacion } from './Paginacion';
import { ProgramaConsulta } from './ProgramaConsulta';
import { EvaluacionDetalle } from './EvaluacionDetalle';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import Datepicker from './Datepicker';

const MySwal = withReactContent(Swal)

const TITLE = "Reportes de Retroalimentación Estudiantil";
const APIURL = process.env.REACT_APP_API_URL;

const dateOptions = {
    year: "2-digit", //"numeric",
    month: "numeric",
    day: "numeric",
};

export class ProgramaEvaluacion extends Component {
    static displayName = ProgramaEvaluacion.name;

    constructor(props) {
        super(props);
        this.state = { total: 0, programa: null, unidad: "", anio: 0, termino: "", page: 1, size: 10, paralelos: [], unidades: [], programas: [], anios: [], terminos: [], loading: true };

        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handlePage = this.handlePage.bind(this);
        this.toggleFormDate = this.toggleFormDate.bind(this);
        this.toggleEstudiantes = this.toggleEstudiantes.bind(this);
        this.toggle = this.toggle.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.downloadUnidadProgramaCohorteAnioTerminoExcel = this.downloadUnidadProgramaCohorteAnioTerminoExcel.bind(this);
        this.downloadPlanificacionAnioExcel = this.downloadPlanificacionAnioExcel.bind(this);
    }

    componentDidMount() {
        const currentUser = this.context.currentUser;
        const { loading } = this.state;
        document.title = TITLE + " - Profesores de mi programa";

        if (currentUser && currentUser != undefined && loading) {
            this.populateData(currentUser);
        }
    }

    componentDidUpdate() {
        const currentUser = this.context.currentUser;

        if (currentUser && currentUser != undefined) {
            this.populateData(currentUser);
        }
    }

    handleDateChange(date, paralelo) {
        const i = this.state.paralelos.indexOf(paralelo);
        console.log("date = " + date);
        const paraleloState = this.state.paralelos[i];
        paraleloState.dtFechaextendidaevaluacion = date;
        this.setState(({ paralelos }) => ({
            paralelos: [
                ...paralelos.slice(0, i),
                {
                    ...paraleloState
                },
                ...paralelos.slice(i + 1)
            ]
        }));
    }


    handleInputChange(event) {
        const currentUser = this.context.currentUser;
        let { unidad, programa, cohorte, anio, termino } = this.state;
        const name = event.target.name;
        const value = event.target.value;

        if (name == "unidad") {
            if (unidad != value) {
                unidad = value;
                this.props.history.push(`/programa-evaluacion/${unidad}`);
            }
        }
        else if (name == "programa") {
            const selected = value.split("_");
            programa = selected[0];
            cohorte = selected[1];
            this.props.history.push(`/programa-evaluacion/${unidad}/${programa}/${cohorte}`);
        }
        else if (name == "anio") {
            anio = value;
            this.props.history.push(`/programa-evaluacion/${unidad}/${programa}/${cohorte}/${anio}`);
        }
        else if (name == "termino") {
            termino = value;
            this.props.history.push(`/programa-evaluacion/${unidad}/${programa}/${cohorte}/${anio}/${termino}`);
        }
    }

    handlePage(url, page, size) {
        this.setState({ loading: true });

        this.props.history.push(`${url}/${page}/${size}`);
    }

    handleSubmit(paralelo) {
        const i = this.state.paralelos.findIndex(p => p.sistema == paralelo.sistema && p.idcurso == paralelo.idcurso && p.identificacion == paralelo.identificacion);
        console.log("paralelo = " + JSON.stringify(paralelo) + " i = " + i);
        //if (paralelo.fechaextendidaevaluacion < paralelo.fechainicioevaluacion) {
        const dtFechainicioevaluacion = new Date(paralelo.fechainicioevaluacion);
        if (paralelo.dtFechaextendidaevaluacion < dtFechainicioevaluacion) {

            MySwal.fire({
                title: <p>Advertencia</p>,
                text: 'La fecha de fin de evaluación no puede ser menor que la fecha de inicio de evaluación',
            });

            this.setState(({ paralelos }) => ({
                paralelos: [
                    ...paralelos.slice(0, i),
                    {
                        ...paralelos[i],
                        fechaextendidaevaluacion: paralelos[i].fechafinevaluacion,
                        dtFechaextendidaevaluacion: paralelos[i].dtFechaextendidaevaluacion
                    },
                    ...paralelos.slice(i + 1)
                ]
            }));
        }

        var paralelos = this.state.paralelos;
        const dateMinValue = new Date('0001-01-01');
        if (paralelo.ultimoCambio == null || paralelo.ultimoCambio == dateMinValue) {
            // insertar fecha evaluacionfin 
            let data = JSON.parse(JSON.stringify(paralelo));

            delete data.docente;
            delete data.verlista;
            delete data.estudiantes;
            delete data.verpdf;
            delete data.formDate;
            //delete data.dtFechaextendidaevaluacion;

            fetch(`${APIURL}/api/admin/extension-evaluacion`, {
                method: 'POST',
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    sistema: paralelo.sistema,
                    idcurso: paralelo.idcurso,
                    anio: paralelo.anio,
                    termino: paralelo.termino,
                    nivelformacion: paralelo.nivelformacion,
                    idnivelformacion: paralelo.idnivelformacion,
                    unidad: paralelo.unidad,
                    programa: paralelo.programa,
                    cohorte: paralelo.cohorte,
                    materia: paralelo.materia,
                    codigo: paralelo.codigo,
                    paralelo: paralelo.paralelo + "",
                    tipocurso: paralelo.tipocurso,
                    grupo: paralelo.grupo,
                    fuente: paralelo.fuente,
                    registrados: paralelo.registrados,
                    evaluados: paralelo.evaluados,
                    identificacion: paralelo.identificacion,
                    apellidos: paralelo.apellidos,
                    nombres: paralelo.nombres,
                    fechainicio: paralelo.fechainicioevaluacion,
                    fechafin: paralelo.fechafinevaluacion,
                    fechaextendida: paralelo.dtFechaextendidaevaluacion,
                    idpersona: paralelo.idpersona
                }),
            })
                .then(res => res.json())
                .then(
                    (p) => {
                        const i = paralelos.findIndex(pa => pa.sistema == p.sistema && pa.idcurso == p.idcurso && pa.identificacion == p.identificacion);
                        paralelos[i].fechafinevaluacion = p.evaluacionfin;
                        paralelos = [
                            ...paralelos.slice(0, i),
                            {
                                ...paralelos[i],
                                verlista: false, estudiantes: [], verpdf: false, formDate: false, dtFechaextendidaevaluacion: new Date(p.evaluacionfin)
                            },
                            ...paralelos.slice(i + 1)
                        ]

                        this.setState({
                            paralelos: paralelos
                        });
                    });
        } else {
            // actualizar fecha evaluacionfin 
            var data = {
                idcurso: paralelo.idcurso,
                identificacion: paralelo.identificacion,
                sistema: paralelo.sistema,
                //fechaextendida: paralelo.fechaextendidaevaluacion
                fechaextendida: paralelo.dtFechaextendidaevaluacion
            };
            var idcurso = paralelo.idcurso;

            fetch(`${APIURL}/api/admin/extension-evaluacion/${idcurso}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            })
                .then(res => res.json())
                .then(
                    (result) => {
                        result.map(p => {
                            const i = paralelos.findIndex(pa => pa.sistema == p.sistema && pa.idcurso == p.idcurso && pa.identificacion == p.identificacion);
                            paralelos[i].fechafinevaluacion = p.evaluacionfin;
                            paralelos = [
                                ...paralelos.slice(0, i),
                                {
                                    ...paralelos[i],
                                    verlista: false, estudiantes: [], verpdf: false, formDate: false, dtFechaextendidaevaluacion: new Date(p.evaluacionfin)
                                },
                                ...paralelos.slice(i + 1)
                            ]
                        });

                        this.setState({
                            paralelos: paralelos
                        });
                    });
        }

    }


    toggleFormDate(paralelo) {
        const i = this.state.paralelos.findIndex(p => p.sistema == paralelo.sistema && p.idcurso == paralelo.idcurso && p.identificacion == paralelo.identificacion);

        this.setState(({ paralelos }) => ({
            paralelos: [
                ...paralelos.slice(0, i),
                {
                    ...paralelos[i],
                    formDate: !paralelos[i].formDate,
                },
                ...paralelos.slice(i + 1)
            ]
        }));
    }

    toggleEstudiantes(paralelo) {
        const { programa } = this.state;
        const i = this.state.paralelos.indexOf(paralelo);
        if (!paralelo.verlista && paralelo.estudiantes && paralelo.estudiantes.length == 0) {
            MySwal.showLoading();
            fetch(`${APIURL}/api/reporte-usuario/planificacion-programa/${paralelo.sistema}/${paralelo.idcurso}/${paralelo.idpersona}`)
                .then(response => response.json())
                .then(data => {
                    MySwal.close();
                    this.setState(({ paralelos }) => ({
                        paralelos: [
                            ...paralelos.slice(0, i),
                            {
                                ...paralelos[i],
                                verlista: !paralelos[i].verlista,
                                estudiantes: data.datos
                            },
                            ...paralelos.slice(i + 1)
                        ]
                    }));
                });
        }
        else {
            this.setState(({ paralelos }) => ({
                paralelos: [
                    ...paralelos.slice(0, i),
                    {
                        ...paralelos[i],
                        verlista: !paralelos[i].verlista,
                    },
                    ...paralelos.slice(i + 1)
                ]
            }));
        }
    }

    toggle(paralelo) {
        const i = this.state.paralelos.indexOf(paralelo);

        if (!paralelo.verpdf) {
            MySwal.fire({
                title: 'Generando PDF...',
                text: 'Espere un momento',
                allowOutsideClick: false,
                didOpen: () => {
                    MySwal.showLoading();
                }
            });
            fetch(`${APIURL}/api/reporte-usuario/reporte-general-pdf/${paralelo.sistema}/${paralelo.idcurso}/${paralelo.idpersona}`)
                .then(response => response.json())
                .then(data => {
                    MySwal.close();
                    this.setState(({ paralelos }) => ({
                        paralelos: [
                            ...paralelos.slice(0, i),
                            {
                                ...paralelos[i],
                                verpdf: !paralelos[i].verpdf,
                                datapdf: data
                            },
                            ...paralelos.slice(i + 1)
                        ]
                    }));
                });
        }
        else {
            this.setState(({ paralelos }) => ({
                paralelos: [
                    ...paralelos.slice(0, i),
                    {
                        ...paralelos[i],
                        verpdf: !paralelos[i].verpdf,
                    },
                    ...paralelos.slice(i + 1)
                ]
            }));

        }
    }

    downloadUnidadProgramaCohorteAnioTerminoExcel() {
        const { anio, termino, unidad, programa, cohorte } = this.state;
        MySwal.showLoading();
        fetch(`${APIURL}/api/reporte-usuario/evaluacion-programa-cohortes`, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ anio: anio, terminos: [termino], unidades: [unidad], idprogramas: [programa], programascohortes: [programa + "_" + cohorte] })
        })
            .then(response => {
                response.blob().then(blob => {
                    MySwal.close();
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = `TASARESPUESTA_${unidad}_${programa}_${cohorte}_${anio}_${termino}.xlsx`;
                    a.click();
                });
            });
    }

    downloadPlanificacionAnioExcel() {
        const { anio } = this.state;
        MySwal.showLoading();
        fetch(`${APIURL}/api/reporte-usuario/evaluacion-programa-cohortes`, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ anio: anio, terminos: [], unidades: [], idprogramas: [], programascohortes: [] })
        })
            .then(response => {
                response.blob().then(blob => {
                    MySwal.close();
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = `TASARESPUESTA_${anio}.xlsx`;
                    a.click();
                });
            });
    }

    formatter(valor) {
        return new Intl.NumberFormat('en-US', { minimumFractionDigits: '2', maximumFractionDigits: '2', signDisplay: 'never' }).format(valor)
    }

    dateformatter = (fecha) => {
        return new Intl.DateTimeFormat('es-EC', { dateStyle: 'short' }).format(fecha)
    }

    renderTable(paralelos) {
        const currentUser = this.context.currentUser;
        const { page, size } = this.state;
        return (
            <>
                <div className="btn-toolbar justify-content-end" role="toolbar" aria-label="Opciones generales">
                    {currentUser && currentUser.usuario && currentUser.roles && currentUser.roles.some(r => r.role == "ADMIN") ?
                        <div className="btn-group" role="group" aria-label="Descargar planificación Excel">
                            <Accion id="de_pl_ex" className="btn btn-primary" action={() => this.downloadPlanificacionAnioExcel()} icon={<BsFileEarmarkExcelFill />} tooltip={"Descargar planificación Excel"} />
                        </div>
                        :
                        <div className="btn-group" role="group" aria-label="Descargar en Excel">
                            <Accion id="de_ex" className="btn btn-success" action={() => this.downloadUnidadProgramaCohorteAnioTerminoExcel()} icon={<BsFileEarmarkExcelFill />} tooltip={"Descargar en Excel"} />
                        </div>
                    }
                </div>
                <table className='table table-striped' aria-labelledby="tabelLabel">
                    <thead>
                        <tr>
                            <th className="text-center" style={{ width: "1%" }}>N°</th>
                            <th className="text-center" style={{ width: "10%" }}>Periodo</th>
                            <th className="text-center" style={{ width: "28%" }}>Materia</th>
                            <th className="text-center" style={{ width: "1%" }}>Par.</th>
                            <th className="text-center" style={{ width: "28%" }}>Docente</th>
                            <th className="text-center" style={{ width: "11%" }}>
                                <span id="tt-pe">Periodo de evaluación</span>
                                <UncontrolledTooltip placement="top" target="tt-pe">
                                    {"día / mes / año"}
                                </UncontrolledTooltip>
                            </th>
                            <th className="text-center" style={{ width: "8%" }}>
                                <span id="tt-fp">Fecha publicación</span>
                                <UncontrolledTooltip placement="top" target="tt-fp">
                                    {"día / mes / año"}
                                </UncontrolledTooltip>
                            </th>
                            <th className="text-center" style={{ width: "1%" }}>% Respuestas</th>
                            <th style={{ width: "1%" }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {paralelos.map((p, index) => {

                            const dtFechainicioevaluacion = new Date(p.fechainicioevaluacion);
                            const dtFechafinevaluacion = new Date(p.fechafinevaluacion);
                            const porcentaje = p.registrados == 0 ? 0 : Math.round(p.evaluados * 100 / p.registrados);
                            return (
                                <tr key={index}>
                                    <td>{((page - 1) * size) + index + 1}.</td>
                                    <td className="text-center">{p.anio + " - " + p.termino}</td>
                                    <td>{p.codigo + " - " + p.materia}</td>
                                    <td className="text-center">{p.paralelo}</td>
                                    <td>{p.docente}</td>
                                    <td>{dtFechainicioevaluacion.toLocaleString('es-EC', dateOptions)} - {dtFechafinevaluacion.toLocaleString('es-EC', dateOptions)}</td>
                                    <td className="text-center">{p.fechapublicacion ? new Date(p.fechapublicacion).toLocaleString('es-EC', dateOptions) : "-"}</td>
                                    <td className="text-center">
                                        <span id={"tt_" + index} >{porcentaje}%</span>
                                        <UncontrolledTooltip placement="bottom" target={"tt_" + index}>
                                            {p.evaluados}/{p.registrados}
                                        </UncontrolledTooltip >
                                    </td>
                                    <td>
                                        <div className="btn-group" role="group" aria-label="Opciones">
                                            <span id={"ttb_" + index}>
                                                <Modal isOpen={p.verlista} className="modal-md">
                                                    <ModalHeader toggle={() => this.toggleEstudiantes(p)}>Lista de estudiantes</ModalHeader>
                                                    <ModalBody>
                                                        <EvaluacionDetalle paralelo={p} estudiantes={p.estudiantes} />
                                                    </ModalBody>
                                                    <ModalFooter>
                                                        <Button color="secondary" onClick={() => this.toggleEstudiantes(p)}>Cerrar</Button>
                                                    </ModalFooter>
                                                </Modal>
                                                <Button onClick={() => this.toggleEstudiantes(p)}>
                                                    <Icon icon={<BsCardChecklist />} />
                                                </Button>
                                            </span>
                                            <UncontrolledTooltip placement="top" target={"ttb_" + index}>
                                                {"Detalle"}
                                            </UncontrolledTooltip>
                                            {p.evaluados > 0 &&
                                                <>
                                                    <span id={"ttb_pdf_" + index}>
                                                        <Link className="btn btn-secondary" to="#" onClick={() => this.toggle(p)}>
                                                            <Icon icon={<BsFilePdfFill />} />
                                                        </Link>
                                                    </span>
                                                    <UncontrolledTooltip placement="top" target={"ttb_pdf_" + index}>
                                                        {"Detalle en PDF"}
                                                    </UncontrolledTooltip>
                                                    <Modal isOpen={p.verpdf} className="modal-xl">
                                                        <ModalHeader toggle={() => this.toggle(p)}>Detalle Paralelo</ModalHeader>
                                                        <ModalBody>
                                                            <embed src={`data:application/pdf;base64,${p.datapdf}`} width={1100} height={600} type='application/pdf' pluginspage="http://www.adobe.com/products/acrobat/readstep2.html" />
                                                        </ModalBody>
                                                        <ModalFooter>
                                                            <Button color="secondary" onClick={() => this.toggle(p)}>Cerrar</Button>
                                                        </ModalFooter>
                                                    </Modal>
                                                    <span id={"ttc_" + index}>
                                                        <Link className="btn btn-secondary" to={`/paralelo-comentarios/${p.sistema}/${p.idcurso}/${p.idpersona}`}>
                                                            <Icon icon={<BsChatLeftTextFill />} />
                                                        </Link>
                                                        {/*  <Link className="btn btn-secondary" to={`/paralelo-comentarios/${p.anio}/${p.termino}/${p.codigo}/${p.paralelo}/${p.identificacion}/${p.idnivelformacion}`}>*/}
                                                        {/*    <Icon icon={<BsChatLeftTextFill />} />*/}
                                                        {/*  </Link>*/}
                                                    </span>
                                                    <UncontrolledTooltip placement="top" target={"ttc_" + index}>
                                                        {"Comentario"}
                                                    </UncontrolledTooltip>
                                                </>
                                            }
                                            {p.registrados > 0 && p.evaluados / p.registrados < 0.75 && currentUser && currentUser.usuario && currentUser.roles
                                                && currentUser.roles.some(r => r.role == "ADMIN") &&
                                                <><br />
                                                    <span id={"ttb_fecha_" + index}>
                                                        <Link className="btn btn-secondary" to="#" onClick={() => this.toggleFormDate(p)}>
                                                            <Icon icon={<BsFillCalendarDateFill />} />
                                                        </Link>
                                                    </span>
                                                    <UncontrolledTooltip placement="top" target={"ttb_fecha_" + index}>
                                                        {"Modificar fin evaluación"}
                                                    </UncontrolledTooltip>
                                                    <Modal isOpen={p.formDate} className="modal-md">
                                                        <ModalHeader toggle={() => this.toggleFormDate(p)}>Modificar fin de evaluación</ModalHeader>
                                                        <ModalBody>
                                                            <div>
                                                                <Row key={0} className="form-group">
                                                                    <Col md={6}>
                                                                        <label className=" control-label" htmlFor="unidad">Fecha fin evaluación:</label>
                                                                    </Col>
                                                                    <Col md={6} className="w-100">
                                                                        <Datepicker id="finevaluacion" name={'finevaluacion[' + index + ']'} placeholder="dd/mm/yy" dateFormat="dd-MM-yy" value={p.dtFechaextendidaevaluacion} onChange={(date) => this.handleDateChange(date, p)} paralelo={p} />
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </ModalBody>
                                                        <ModalFooter>
                                                            <Button color="success" onClick={() => this.handleSubmit(p)}>Guardar</Button>
                                                            <Button color="danger" onClick={() => this.toggleFormDate(p)}>Cancelar</Button>
                                                        </ModalFooter>
                                                    </Modal>
                                                </>
                                            }
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan={9}>
                                <Paginacion total={this.state.total} page={this.state.page} size={this.state.size} url={`/programa-evaluacion/${this.state.unidad}/${this.state.programa}/${this.state.cohorte}/${this.state.anio}/${this.state.termino}`} handle={this.handlePage} />
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </>
        );
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderTable(this.state.paralelos);
        let programas_cohortes = [];
        this.state.programas.forEach(p => {
            if (programas_cohortes.every(pc => pc.value !== p.idprograma + "_" + p.cohorte)) {
                programas_cohortes.push({ label: p.programa + " Cohorte " + p.cohorte, value: p.idprograma + "_" + p.cohorte });
            }
        });

        return (
            <div>
                <h1 id="tabelLabel">Evaluación de mi programa</h1>
                <ProgramaConsulta unidadOptions={this.state.unidades} unidadValue={this.state.unidad} programaOptions={programas_cohortes} programaValue={this.state.programa + '_' + this.state.cohorte}
                    anioOptions={this.state.anios} anioValue={this.state.anio} terminoOptions={this.state.terminos} terminoValue={this.state.termino} onInputChange={this.handleInputChange} />
                <br />
                {contents}
            </div>
        );
    }

    async populateData(currentUser) {
        const roles = currentUser.roles;
        //console.log("roles = " + JSON.stringify(roles));

        const uniqueScopes = new Set();

        const filteredRoles = roles
            .filter(r =>
                (r.role === "DECANO" || r.role === "SUBDECANO" || r.role === "COORDINADOR_GENERAL") &&
                r.scope !== "ESPL" &&
                !uniqueScopes.has(r.scope)
            )
            .map(r => {
                uniqueScopes.add(r.scope);
                return { value: r.scope, label: r.scopeName };
            });

        const unidades = filteredRoles.sort((a, b) => a.value.localeCompare(b.value));

        let unidad = this.props.match.params["unidad"] || this.state.unidad || unidades.map(u => u.value)[0];
        //console.log("unidades = " + JSON.stringify(unidades));
        const programas = roles.filter(r => r.role == "COORDINADOR_CARRERA" || r.role == "COORDINADOR_PROGRAMA").map((r) => ({ value: r.scope, label: r.scopeName }));

        if (programas.length == 0 && unidades.length == 0) return;

        let programas_cohortes = this.state.programas;
        let programa = 0;
        let cohorte = 0;
        let anio = "";
        let termino = "";
        let anios = [];
        let terminos = [];

        if (programas_cohortes.length == 0 || unidad != this.state.unidad) {
            const responseProgramasCohortes = await fetch(`${APIURL}/api/reporte-usuario/planificacion-programa-cohortes`, {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ idprogramas: programas.map(pra => pra.value), unidad: unidad, unidades: unidades.map(u => u.value) })
            });
            const dataProgramasCohortes = await responseProgramasCohortes.json();

            if (dataProgramasCohortes.datos.length > 0) {
                programas_cohortes = dataProgramasCohortes.datos;

                if (unidad != this.state.unidad && this.props.match.params["programa"] === undefined && this.props.match.params["cohorte"] === undefined
                    && this.props.match.params["anio"] === undefined && this.props.match.params["termino"] === undefined) {

                    programa = programas_cohortes[0].idprograma;
                    cohorte = programas_cohortes[0].cohorte;
                    unidad = programas_cohortes[0].codunidad;
                    anio = programas_cohortes[0].anio;
                    termino = programas_cohortes[0].termino
                } else {
                    programa = parseInt(this.props.match.params["programa"]) || this.state.programa || programas_cohortes[0].idprograma;
                    cohorte = parseInt(this.props.match.params["cohorte"]) || this.state.cohorte || programas_cohortes[0].cohorte;
                    anio = this.props.match.params["anio"] || this.state.anio || programas_cohortes[0].anio;
                    termino = this.props.match.params["termino"] || this.state.termino || programas_cohortes[0].termino;
                }

            } else {
                programa = 0;
                cohorte = 0;
                unidad = "";
                anio = "";
                termino = "";
            }
        } else {
            programa = parseInt(this.props.match.params["programa"]) || this.state.programa || programas_cohortes[0].idprograma;
            cohorte = parseInt(this.props.match.params["cohorte"]) || this.state.cohorte || programas_cohortes[0].cohorte;
            anio = this.props.match.params["anio"] || this.state.anio || programas_cohortes[0].anio;
            termino = this.props.match.params["termino"] || this.state.termino || programas_cohortes[0].termino;
        }

        let programa_cohorte_seleccionados = [];
        if (programa != 0 && cohorte != 0)
            programa_cohorte_seleccionados = programas_cohortes.filter(pc => pc.idprograma == programa && pc.cohorte == cohorte);

        programa_cohorte_seleccionados.forEach(pc => {
            if (anios.every(a => a !== pc.anio)) {
                anios.push(pc.anio);
            }
            if (terminos.every(t => t !== pc.termino)) {
                terminos.push(pc.termino);
            }
        });

        anio = this.props.match.params["anio"] || (anios.includes(this.state.anio) ? this.state.anio : anios[0]);
        termino = this.props.match.params["termino"] || (terminos.includes(this.state.termino) ? this.state.termino : terminos[0]);

        const page = parseInt(this.props.match.params["page"]) || this.state.page || 1;
        const size = parseInt(this.props.match.params["size"]) || this.state.size || 10;

        if (this.state.anio != 0 && unidad == this.state.unidad && programa == this.state.programa && cohorte == this.state.cohorte && anio == this.state.anio && termino == this.state.termino && page == this.state.page && size == this.state.size)
            return;

        MySwal.fire({
            title: 'Cargando cursos...',
            text: 'Espere un momento',
            allowOutsideClick: false,
            didOpen: () => {
                MySwal.showLoading();
            }
        });
        console.log("anio=" + anio + " termino=" + termino + " state_anio = " + this.state.anio + " state_termino = " + this.state.termino);
        const response = await fetch(`${APIURL}/api/reporte-usuario/planificacion-programa-periodo/${programa}/${cohorte}/${anio}/${termino}/${page}/${size}`);
        const data = await response.json();
        const paralelos = data.datos.map(
            (p) => {
                const fechaextendida = new Date(p.fechafinevaluacion);
                return { ...p, docente: p.apellidos + " " + p.nombres, verlista: false, estudiantes: [], verpdf: false, formDate: false, dtFechaextendidaevaluacion: fechaextendida };
            }
        );

        this.setState({ total: data.total, unidades: unidades, unidad: unidad, programas: programas_cohortes, programa: programa, cohorte: cohorte, anios: anios, anio: anio, terminos: terminos, termino: termino, page: page, size: size, paralelos: paralelos, loading: false });
        MySwal.close();
    }
}
ProgramaEvaluacion.contextType = AppContext;